// components/BirthYearForm.js
import React, { useEffect, useState } from 'react';
import { 
  Typography, 
  TextField,
  Box,
  Slider,
  Stack
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function BirthYearForm() {
  const currentYear = new Date().getFullYear();
  const {state, actions} = useAppContext();
  const [value, setValue] = useState({
    birthYear: state.birthYear || '',
    retirementAge: state.retirementAge || Math.max(state.age || 0, 55),
  });

  useEffect(() => {
    setValue({
      birthYear: state.birthYear,
      retirementAge: state.retirementAge || Math.max(state.age || 0, 55),
    });
  }, [state.birthYear, state.retirementAge, state.age]);

  const minAge = state.age || 18;
  const maxAge = 85;

  const handleChange = (e) => {
    const input = e.target.value;
  
    setValue(prev => ({
      ...prev,
      birthYear: input
    }));
  
    const isValid = /^[1-2][0-9]{3}$/.test(input);
    if (!isValid) return;
  
    const birthYear = parseInt(input, 10);
    const age = currentYear - birthYear;
  
    // Update context
    actions.updateFormData('birthYear', birthYear);
    actions.updateFormData('age', age);
  
    const defaultRetirementAge = Math.max(age, 55);
    actions.updateFormData('retirementAge', defaultRetirementAge);
    actions.updateFormData('yearsForRetirement', defaultRetirementAge - age);
  
    setValue(prev => ({
      ...prev,
      retirementAge: defaultRetirementAge
    }));
  };
  
  
  
  
  const handleChangeRetirement = (e, newValue) => {
    // Handle both slider and text field events
    let retirementAge = newValue !== undefined ? newValue : parseInt(e.target.value, 10);
    if (isNaN(retirementAge)) retirementAge = minAge;
    
    // console.log("retirement age: ", retirementAge);
    
    setValue(prev => ({
      ...prev,
      retirementAge: retirementAge
    }));
    
    actions.updateFormData('retirementAge', retirementAge);
    const yearsForRetirement = retirementAge - state.age;
    actions.updateFormData('yearsForRetirement', yearsForRetirement);
    // console.log("years for retirement: ", yearsForRetirement);
  };

  return (
    <>
      <Typography variant="h6" component="h2" gutterBottom>
        {state.clientName.split(" ")[0]}, When were you born?
      </Typography>

      <Box sx={{ mt: 2 }}>
      <TextField
          label="Birth Year"
          value={value.birthYear || ''}
          onChange={handleChange}
          fullWidth
          type="tel"
          inputMode="numeric"
          error={
            !!value.birthYear && (
              !/^[1-2][0-9]{3}$/.test(value.birthYear) ||
              (state.age && (state.age < 18 || state.age > 85))
            )
          }
          helperText={
            !value.birthYear
              ? " "
              : !/^[1-2][0-9]{3}$/.test(value.birthYear)
                ? "Please enter a valid 4-digit year"
                : state.age < 18 || state.age > 85
                  ? "Your age should be between 18 and 85"
                  : " "
          }
      />

      </Box>
      
      <br />
      
      <Typography variant="h6" component="h2" gutterBottom>
        And at what age do you wish to become financially free (or retire)?
      </Typography>
      
      <Box sx={{ mt: 4, mb: 2 }}>
        {/* <Box sx={{ display: 'flex', alignItems: 'center' }}> */}
          <Slider
            value={value.retirementAge || minAge}
            onChange={handleChangeRetirement}
            aria-labelledby="retirement-age-slider"
            min={minAge}
            max={maxAge}
            valueLabelDisplay="on"
            sx={{ mr: 2, flexGrow: 1 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          variant="body2"
          // onClick={() => setVal(MIN)}
          sx={{ cursor: 'pointer' }}
        >
          {minAge}
        </Typography>
        <Typography
          variant="body2"
          // onClick={() => setVal(MAX)}
          sx={{ cursor: 'pointer' }}
        >
          {maxAge}
        </Typography>
      </Box>
          {/* <TextField
            value={value.retirementAge || ''}
            type="tel"
            inputMode="numeric"
            onChange={(e) => handleChangeRetirement(e)}
            inputProps={{
              min: minAge,
              max: maxAge,
              'aria-labelledby': 'retirement-age-slider',
              style: { width: '60px' }
            }}
          /> */}
        {/* </Box> */}
        
        <Box sx={{ mt: 4 }}>
          {state.age > 0 && state.yearsForRetirement > -1 && 
            (state.yearsForRetirement === 0 ? 
              (<>
                <Typography variant="body1" fontWeight="bold">
                  Congratulations, {state.clientName.split(" ")[0]}, on your retirement. You have earned it!
                </Typography>
                <Typography variant="body1">
                  Let's ensure you are fully prepared for a comfortable retirement in full.
                </Typography>
              </>) :
              state.yearsForRetirement < 6 ?
              (<>
                <Typography variant="body1" fontWeight="bold">
                  Not that far {state.clientName.split(" ")[0]}. You are just <span style={{color: "#1976d2"}}>{state.yearsForRetirement} {state.yearsForRetirement < 2 ? "year" : "years"} </span>away from retirement.
                </Typography>
                <Typography variant="body1">
                  Let's ensure you are fully prepared and on track to achieve your financial freedom.
                </Typography>
              </>) :
              (<>
                <Typography variant="body1" fontWeight="bold">
                  Time is by your side, {state.clientName.split(" ")[0]}! You are <span style={{color: "#1976d2"}}>{state.yearsForRetirement} years </span>away from retirement.
                </Typography>
                <Typography variant="body1">
                  Let's ensure that prudent asset allocation and consistent compounding keep working for you to take you home.
                </Typography>
              </>)
            )
          }
        </Box> 
      </Box>
    </>
  );
}

export default BirthYearForm;